import { render, staticRenderFns } from "./CommunityResolutionCard.vue?vue&type=template&id=2a20ef32&scoped=true&"
import script from "./CommunityResolutionCard.vue?vue&type=script&lang=ts&"
export * from "./CommunityResolutionCard.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityResolutionCard.vue?vue&type=style&index=0&id=2a20ef32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a20ef32",
  null
  
)

export default component.exports